import React, { useState } from 'react'

import CampaignCreateForm from './CampaignCreateForm'
import LineItemForm from './LineItemForm'
import AdsForm from './AdsForm'
import CollapsibleSection from '../../../../components/CollapsibleSection'

import { creationSections } from './index.css'

type StepType = 'campaign' | 'lineItem' | 'ads'

const CreateFormSelector: React.FC = () => {
  const [activeStep, setActiveStep] = useState<StepType>('campaign')

  const handleCampaignSuccess = () => {
    setActiveStep('lineItem')
  }

  const handleLineItemSuccess = () => {
    setActiveStep('ads')
  }

  const handleAdsSuccess = () => {
    console.log('All steps completed successfully!')
    // Reset or redirect as needed
  }

  return (
    <div className={creationSections}>
      <CollapsibleSection title={'Campaign Settings'} showIcon={true} defaultOpen={true}>
        {activeStep === 'campaign' && <CampaignCreateForm onSuccess={handleCampaignSuccess} />}
      </CollapsibleSection>

      {/*todo replace the text to dynamic based on the selected platform*/}
      <CollapsibleSection title={'Ad set / ad group settings'} showIcon={true} disabled={activeStep !== 'lineItem'}>
        {activeStep === 'lineItem' && <LineItemForm onSuccess={handleLineItemSuccess} />}
      </CollapsibleSection>

      <CollapsibleSection title={'Meta Ads'} showIcon={true} disabled={activeStep !== 'ads'}>
        {activeStep === 'ads' && <AdsForm onSuccess={handleAdsSuccess} />}
      </CollapsibleSection>
    </div>
  )
}

export default CreateFormSelector
